// import { useEffect, useState, useRef } from "react";
// import { ChevronDownIcon } from "@heroicons/react/20/solid";
// import { ChevronRightIcon } from "@heroicons/react/24/solid";
// import { useAssessment } from "../components/assessmentContext";
// import { useLocation, useNavigate } from "react-router-dom";
// import { fetchAttachmentsForQuestiongid, GetAnswerData, GetChoicesByQID, post_InsertAnswer, sendAttachments } from "../apis/services/csaApi";
// import * as environment from '../apis/env_config/environment'

// export default function Question() {
//   const [openPanels, setOpenPanels] = useState({});
//   const { activeAssessment } = useAssessment();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { groupname, enablers, questions, topic, phase, groupId, allGroupItems } =
//     location.state || {};
//   const [activeTab, setActiveTab] = useState(location.state?.activeTab || 0);

//   // State for question responses
//   const [visiblePanels, setVisiblePanels] = useState({});
//   const [currentSelections, setCurrentSelections] = useState({});
//   const [desiredSelections, setDesiredSelections] = useState({});
//   const [remarks, setRemarks] = useState({});
//   const [optionsMap, setOptionsMap] = useState({});
//   const [groupedQuestions, setGroupedQuestions] = useState({});

//   const get_Attachments_Data = async (newGroupedQuestions) => {
//     try {
//       const rawData = await fetchAttachmentsForQuestiongid(
//         localStorage.getItem("uId"),
//         localStorage.getItem("AssessmentId"),
//         groupId
//       );
//       console.log("fetchAttachmentsForQuestiongid", rawData);
//       if (rawData && rawData.length > 0) {
       
//       }
//     } catch (error) {
//       console.error(`Error fetching`, error);
//     }
//   }

//   const get_Answer_Data = async (newGroupedQuestions) => {
//     try {
//       const rawData = await GetAnswerData(
//         localStorage.getItem("uId"),
//         localStorage.getItem("AssessmentId"),
//         groupId
//       );
//       console.log("GetAnswerData", rawData);
//       if (rawData && rawData.length > 0) {
        
//         // Initialize selections after groupedQuestions is set
//         const {
//           initialCurrentSelections,
//           initialDesiredSelections,
//           initialRemarks,
//           initialKpiScores
//         } = initializeSelectionsFromApiData(rawData, newGroupedQuestions);

//         setCurrentSelections(initialCurrentSelections);
//         setDesiredSelections(initialDesiredSelections);
//         setRemarks(initialRemarks);
//         setKpiScores(initialKpiScores);
//       } else {
//       }
//     } catch (error) {
//       console.error(`Error fetching`, error);
//     }
//   }

//   // Initialize selections from API data
//   const initializeSelectionsFromApiData = (apiData, groupedQuestions) => {
//     const initialCurrentSelections = {};
//     const initialDesiredSelections = {};
//     const initialRemarks = {};
//     const initialKpiScores = {};

//     apiData.forEach(item => {
//       const qid = item.qid;
//       console.log("qidII", qid);

//       console.log("Object.keys(groupedQuestions)", groupedQuestions);

//       // Find the question in groupedQuestions to get options
//       const category = Object.keys(groupedQuestions).find(cat =>
//         groupedQuestions[cat].some(q => q.qid === qid)
//       );
//       const question = groupedQuestions[category]?.find(q => q.qid === qid);

//       if (question) {
//         // Find current selection index based on currentID (oid)
//         const currentOptionIndex = question.options.findIndex(
//           option => option.oid === item.currentID
//         );
//         if (currentOptionIndex !== -1) {
//           initialCurrentSelections[qid] = currentOptionIndex;
//         }

//         // Find desired selection index based on destinationID (oid)
//         const desiredOptionIndex = question.options.findIndex(
//           option => option.oid === item.destinationID
//         );
//         if (desiredOptionIndex !== -1) {
//           initialDesiredSelections[qid] = desiredOptionIndex;
//         }

//         // Set remarks if available
//         if (item.remark) {
//           initialRemarks[qid] = item.remark;
//         }

//         // Set KPI score if available
//         if (item.kpiScore !== null && item.kpiScore !== undefined) {
//           initialKpiScores[qid] = item.kpiScore;
//         }
//       }
//     });
//     console.log("initialCurrentSelections", initialCurrentSelections);
//     console.log("initialDesiredSelections", initialDesiredSelections);
//     console.log("initialRemarks", initialRemarks);
//     console.log("initialKpiScores", initialKpiScores);

//     return {
//       initialCurrentSelections,
//       initialDesiredSelections,
//       initialRemarks,
//       initialKpiScores
//     };
//   };


//   // Update the fetchOptionsAndGroupQuestions useEffect to store both answerText and oid
//   useEffect(() => {
//     const fetchOptionsAndGroupQuestions = async () => {
//       if (!allGroupItems) return;

//       const newOptionsMap = {};
//       const newGroupedQuestions = {
//         "Human Talent & Organization": [],
//         "Standardized Process & Governance": [],
//         "Tools & Technology": [],
//       };
//       console.log("allGroupItemsd", allGroupItems);
//       for (const item of allGroupItems) {
//         try {
//           const rawData = await GetChoicesByQID(
//             null,
//             item.id,
//             localStorage.getItem("AssessmentId"),
//             localStorage.getItem("userName"),
//             localStorage.getItem("languageId")
//           );
//           console.log("GetChoicesByQID", rawData);


//           if (rawData && rawData.length > 0 && rawData[0].length > 0) {
//             // Store both answerText and oid for each option
//             newOptionsMap[item.id] = rawData[0].map(option => ({
//               text: option.answerText,
//               oid: option.oid
//             }));
//           } else {
//             // Default options with dummy oids if no data from API
//             newOptionsMap[item.id] = [
//               { text: "Not in Place", oid: 1 },
//               { text: "Partially in Place", oid: 2 },
//               { text: "Mostly in Place", oid: 3 },
//               { text: "Fully in Place", oid: 4 }
//             ];
//           }

//           if (newGroupedQuestions[item.enablers]) {
//             newGroupedQuestions[item.enablers].push({
//               qid: item.id,
//               question: item.questions,
//               options: newOptionsMap[item.id],
//               itemData: item
//             });
//           }
//         } catch (error) {
//           console.error(`Error fetching options for QID ${item.id}:`, error);
//           newOptionsMap[item.id] = [
//             { text: "Not in Place", oid: 1 },
//             { text: "Partially in Place", oid: 2 },
//             { text: "Mostly in Place", oid: 3 },
//             { text: "Fully in Place", oid: 4 }
//           ];
//         }
//       }
//       console.log("newGroupedQuestions", newGroupedQuestions);

//       setOptionsMap(newOptionsMap);
//       setGroupedQuestions(newGroupedQuestions);
//       get_Attachments_Data(newGroupedQuestions);
//       get_Answer_Data(newGroupedQuestions);
//     }

//     fetchOptionsAndGroupQuestions();
//   }, [allGroupItems]);

//   const goBackToQuestionnaires = () => {
//     navigate("/questionnaires", {
//       state: {
//         activeTab,
//         openPhase: phase,
//       },
//     });
//   };

//   const togglePanel = (panelName) => {
//     setOpenPanels((prevState) => ({
//       ...prevState,
//       [panelName]: !prevState[panelName],
//     }));
//   };

//   const toggleQuestionPanel = (qid) => {
//     setVisiblePanels((prev) => ({ ...prev, [qid]: !prev[qid] }));
//   };

//   // Update the logQuestionData function to include oid
//   const logQuestionData = async (qid, changeType, value = null) => {
//     const category = Object.keys(groupedQuestions).find(cat =>
//       groupedQuestions[cat].some(q => q.qid === qid)
//     );
//     const question = groupedQuestions[category]?.find(q => q.qid === qid);

//     if (!question) return;

//     const item = question.itemData;
//     console.log("question", question);
//     console.log("item", item);


//     const dataToLog = {
//       qid: qid,
//       question: question.question,
//       options: question.options.map((option, index) => ({
//         optionText: option.text, // Now using option.text which will include both answerText and oid
//         optionId: option.oid, // Using the actual oid from the API
//         selected: currentSelections[qid] === index || desiredSelections[qid] === index,
//         currentSelection: currentSelections[qid] === index,
//         desiredSelection: desiredSelections[qid] === index
//       })),
//       currentValue: changeType === 'current' ? value : currentSelections[qid] !== undefined
//         ? {
//           text: question.options[currentSelections[qid]].text,
//           oid: question.options[currentSelections[qid]].oid
//         }
//         : null,
//       desiredValue: changeType === 'desired' ? value : desiredSelections[qid] !== undefined
//         ? {
//           text: question.options[desiredSelections[qid]].text,
//           oid: question.options[desiredSelections[qid]].oid
//         }
//         : null,
//       kpiScore: changeType === 'kpiScore' ? value : kpiScores[qid] || item?.kpiScore || null,
//       attachments: {
//         attachment1: changeType === 'attachment1' ? value : item?.attachment1 || null,
//         attachment2: changeType === 'attachment2' ? value : item?.attachment2 || null,
//         attachment3: changeType === 'attachment3' ? value : item?.attachment3 || null,
//         attachment4: changeType === 'attachment4' ? value : item?.attachment4 || null,
//         attachment5: changeType === 'attachment5' ? value : item?.attachment5 || null
//       },
//       remarks: changeType === 'remarks' ? value : remarks[qid] || null,
//       changeType: changeType
//     };


//     let apiData = {
//       qid: qid,
//       Cid: 0, // Default to 0
//       DId: 0, // Default to 0
//       UId: localStorage.getItem("uId"),
//       AID: localStorage.getItem("AssessmentId"),
//       Remarks: dataToLog.remarks || "",
//       Eid: item.enablerId || 0,
//       GID: item.groupId || 0,
//       Fid: 0,
//       GroupName: groupname || "",
//       UserName: "admin",
//       Ip: "",
//       kpiScore: dataToLog.kpiScore || 0,
//     };

//     // Set Cid or DId based on changeType
//     if (changeType === 'current' && value?.oid) {
//       apiData.Cid = value.oid;
//     } else if (changeType === 'desired' && value?.oid) {
//       console.log("Desired Value:", value);

//       apiData.DId = value.oid;
//     } else if (changeType === 'remarks') {
//       // Only update remarks, keep existing Cid/DId if available
//       apiData.Remarks = value || "";
//       if (currentSelections[qid] !== undefined) {
//         apiData.Cid = question.options[currentSelections[qid]].oid;
//       }
//       if (desiredSelections[qid] !== undefined) {
//         apiData.DId = question.options[desiredSelections[qid]].oid;
//       }
//     } else if (changeType === 'kpiScore') {
//       // Only update KPI score, keep existing Cid/DId if available
//       if (currentSelections[qid] !== undefined) {
//         apiData.Cid = question.options[currentSelections[qid]].oid;
//       }
//       if (desiredSelections[qid] !== undefined) {
//         apiData.DId = question.options[desiredSelections[qid]].oid;
//       }
//     }

//     // Make API call
//     try {
//       const response = await post_InsertAnswer(apiData);
//       console.log('API Response:', response);
//     } catch (error) {
//       console.error('API Error:', error);
//     }

//     console.log(`Question ${qid} Update (${changeType}):`, dataToLog);
//     return dataToLog;
//   };


//   const logEnablerData = (category) => {
//     if (!groupedQuestions[category]) return;

//     const enablerData = {
//       category: category,
//       questions: [],
//       completeStatus: getCategoryStatus(category).includes('green') ? 'complete' : 'incomplete'
//     };

//     groupedQuestions[category].forEach(questionData => {
//       const qid = questionData.qid;
//       enablerData.questions.push(logQuestionData(qid, 'enabler'));
//     });

//     console.log(`Enabler ${category} Data:`, enablerData);
//     return enablerData;
//   };

//   const handleCurrentChange = (qid, index) => {
//     const category = Object.keys(groupedQuestions).find(cat =>
//       groupedQuestions[cat].some(q => q.qid === qid)
//     );
//     const question = groupedQuestions[category]?.find(q => q.qid === qid);
//     const selectedOption = question?.options[index];

//     setCurrentSelections(prev => ({ ...prev, [qid]: index }));

//     setDesiredSelections(prev => {
//       if (prev[qid] !== undefined && prev[qid] < index) {
//         const updated = { ...prev };
//         delete updated[qid];
//         return updated;
//       }
//       return prev;
//     });

//     logQuestionData(qid, 'current', {
//       text: selectedOption.text,
//       oid: selectedOption.oid
//     });
//     logEnablerData(category);
//   };

//   const handleDesiredChange = (qid, index) => {
//     if (currentSelections[qid] === undefined || index >= currentSelections[qid]) {
//       const category = Object.keys(groupedQuestions).find(cat =>
//         groupedQuestions[cat].some(q => q.qid === qid)
//       );
//       const question = groupedQuestions[category]?.find(q => q.qid === qid);
//       const selectedOption = question?.options[index];

//       setDesiredSelections(prev => ({ ...prev, [qid]: index }));
//       logQuestionData(qid, 'desired', {
//         text: selectedOption.text,
//         oid: selectedOption.oid
//       });
//       logEnablerData(category);
//     }
//   };

//   const handleRemarksChange = (qid, value) => {
//     setRemarks((prev) => ({ ...prev, [qid]: value }));

//     // Get the category for this question
//     const category = Object.keys(groupedQuestions).find(cat =>
//       groupedQuestions[cat].some(q => q.qid === qid)
//     );

//     logQuestionData(qid, 'remarks', value);
//     logEnablerData(category);
//   };

//   const [kpiScores, setKpiScores] = useState({});
//   const handleKpiScoreChange = (qid, value) => {
//     setKpiScores(prev => ({
//       ...prev,
//       [qid]: value
//     }));

//     // Get the category for this question
//     const category = Object.keys(groupedQuestions).find(cat =>
//       groupedQuestions[cat].some(q => q.qid === qid)
//     );

//     logQuestionData(qid, 'kpiScore', value);
//     logEnablerData(category);
//   };


//   // Inside your component
//   const [uploadingIndex, setUploadingIndex] = useState(null);
//   const fileInputRefs = useRef([]);

//   const [attachments, setAttachments] = useState({});
//   const handleFileUpload = async (qid, index, e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setUploadingIndex(index);
//     const attachmentKey = `attachment${index + 1}`;

//     try {
//       // Create FormData to send the file
//       const formData = new FormData();
//       formData.append('file', file);
//       formData.append('qid', qid);
//       formData.append('index', index + 1); // attachment1, attachment2 etc.
//       formData.append('assessmentId', localStorage.getItem("AssessmentId"));
//       formData.append('userName', localStorage.getItem("userName"));
//       formData.append('uid', localStorage.getItem("uId"));
//       formData.append('gid', groupId);

//       // Upload the file
//       const uploadResponse = await sendAttachments({
//         file,
//         qid,
//         index: index + 1,
//         assessmentId: localStorage.getItem("AssessmentId"),
//         userName: localStorage.getItem("userName"),
//         uid: localStorage.getItem("uId"),
//         gid:groupId
//       });

//       // Get the file path from the response
//       const filePath = uploadResponse.filePath;
//       console.log('File uploaded successfully:', filePath);

//       // Update attachments state
//       setAttachments(prev => ({
//         ...prev,
//         [qid]: {
//           ...prev[qid],
//           [attachmentKey]: uploadResponse.filePath
//         }
//       }));

//       // Update your state with the new attachment URL
//       // This would depend on your state management
//       // For example, you might want to store the filePath in your state

//       logQuestionData(qid, attachmentKey, {
//         name: file.name,
//         type: file.type,
//         size: file.size,
//         url: filePath, // Use the server path here
//         lastModified: file.lastModified
//       });

//       const category = Object.keys(groupedQuestions).find(cat =>
//         groupedQuestions[cat].some(q => q.qid === qid)
//       );
//       logEnablerData(category);

//     } catch (error) {
//       console.error('Error uploading file:', error);
//       logQuestionData(qid, `${attachmentKey}_error`, error.message);
//     } finally {
//       setUploadingIndex(null);
//     }
//   };

//   const getCategoryStatus = (category) => {
//     if (!groupedQuestions[category] || groupedQuestions[category].length === 0) {
//       return "bg-red-600";
//     }

//     const questions = groupedQuestions[category];
//     let hasComplete = false;
//     let hasPartial = false;
//     let hasNone = false;

//     questions.forEach((question) => {
//       const qid = question.qid;
//       const hasCurrent = currentSelections[qid] !== undefined;
//       const hasDesired = desiredSelections[qid] !== undefined;

//       if (hasCurrent && hasDesired) {
//         hasComplete = true;
//       } else if (hasCurrent || hasDesired) {
//         hasPartial = true;
//       } else {
//         hasNone = true;
//       }
//     });

//     if (hasComplete && !hasNone) {
//       return "bg-[#02a902]";
//     } else {
//       return "bg-[#f40009]";
//     }
//   };

//   // Evidence modal
//   const [modalData, setModalData] = useState({
//     isOpen: false,
//     imageSrc: null,
//     title: null
//   });

//   const openImageModal = (src, title = null) => {
//     setModalData({ isOpen: true, imageSrc: src, title });
//   };

//   const closeModal = () => {
//     setModalData({ isOpen: false, imageSrc: null, title: null });
//   };

//   useEffect(() => {
//     if (modalData.isOpen) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "";
//     }

//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, [modalData.isOpen]);


//   return (
//     <div className="wrapper">
//       <div className="section-questions" style={{ alignItems: "flex-start" }}>
//         <h1 className="main-heading">
//           {topic} {localStorage.getItem("AssessmentText")} Breakdown
//         </h1>

//         {/* Breadcrumb navigation */}
//         <nav
//           className="text-3xl w-full mb-12 mt-24"
//           style={{ fontFamily: "TCCC-UnityTextPC-Bold", color: "#3c3c3a" }}
//         >
//           <ol className="flex items-center relative">
//             <li className="flex items-center hover:text-[#f40009]">
//               <button onClick={goBackToQuestionnaires} className="text-4xl">
//                 {topic}
//               </button>
//               <ChevronRightIcon className="h-5 w-5 mx-3 text-gray-900" />
//             </li>
//             <li className="flex items-center">
//               <span className="text-4xl">{phase}</span>
//               <ChevronRightIcon className="h-5 w-5 mx-3 text-gray-900" />
//             </li>
//             <li className="flex items-center">
//               <span className="text-black m-0 text-4xl">{groupname}</span>
//             </li>
//             <span
//               onClick={() =>
//                 setModalData({
//                   isOpen: true,
//                   imageSrc: `/assets/elements/${groupname}.svg`,
//                   title: groupname
//                 })
//               }
//               className="absolute top-0 right-0 w-12 h-12 bg-[#f40009] rounded-full cursor-pointer"
//             >
//               <span className="absolute top-[51%] left-1/2 -translate-x-[50%] -translate-y-[55%] text-3xl text-white">
//                 i
//               </span>
//             </span>
//           </ol>
//         </nav>

//         {/* Questions section - grouped by category */}
//         <div className="methods-content-container">
//           <ul>
//             {Object.entries(groupedQuestions).map(
//               ([category, questions]) =>
//                 questions.length > 0 && (
//                   <li key={category} className="text-gray-800 font-medium">
//                     <div>
//                       <button
//                         className={`flex content-center items-center w-full ${getCategoryStatus(
//                           category
//                         )}`}
//                         onClick={() => togglePanel(category)}
//                       >
//                         <div
//                           className="phase w-[6rem] border-r border-[#ccc]"
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                           }}
//                         >
//                           <img
//                             className="w-[3rem] h-[3rem]"
//                             src={
//                               category === "Human Talent & Organization"
//                                 ? "/assets/main/hr.svg"
//                                 : category ===
//                                   "Standardized Process & Governance"
//                                   ? "/assets/main/process.svg"
//                                   : "/assets/main/it.svg"
//                             }
//                             alt=""
//                           />
//                         </div>
//                         <p
//                           className="phase"
//                           style={{
//                             padding: "1rem 1rem",
//                             fontFamily: "TCCC-UnityTextPC-Bold",
//                             fontSize: "2.5rem",
//                           }}
//                         >
//                           {category}
//                         </p>
//                         <ChevronDownIcon
//                           className={`h-10 w-10 ml-auto mr-4 text-white transition-transform duration-200 ${openPanels[category] ? "rotate-180" : ""
//                             }`}
//                         />
//                       </button>

//                       {openPanels[category] && (
//                         <div className="group-name-container px-4 bg-white">
//                           {questions.map((questionData, qIndex) => {
//                             const item = questionData.itemData;
//                             return (
//                               <div
//                                 key={qIndex}
//                                 className="question-container px-3"
//                               >
//                                 <div
//                                   className="text-2xl px-6 my-5 border-l-2 border-[#f40009] relative"
//                                   style={{
//                                     fontFamily: "TCCC-UnityTextPC-Regular",
//                                   }}
//                                 >
//                                   <p className="w-[92%] text-[2.4rem] leading-normal">
//                                     {questionData.qid}. {questionData.question}
//                                   </p>
//                                   <span
//                                     style={{
//                                       fontFamily: "TCCC-UnityTextPC-Bold",
//                                     }}
//                                     onClick={() =>
//                                       toggleQuestionPanel(questionData.qid)
//                                     }
//                                     className="absolute right-0 top-1/2 -translate-y-1/2 w-14 h-14 bg-[#f40009] rounded-full cursor-pointer"
//                                   >
//                                     <span className="absolute top-[45%] left-1/2 -translate-x-[45%] -translate-y-[55%] text-3xl text-white">
//                                       e
//                                     </span>
//                                   </span>
//                                   {item?.hqLink && (
//                                     <span
//                                       onClick={() => openImageModal(item.hqLink, questionData.question)}
//                                       className="absolute right-[5.2rem] top-1/2 -translate-y-1/2 w-14 h-14 bg-[#f40009] rounded-full cursor-pointer"
//                                     >
//                                       <span className="absolute top-[51%] left-1/2 -translate-x-[45%] -translate-y-[55%] text-4xl text-white">
//                                         i
//                                       </span>
//                                     </span>
//                                   )}
//                                 </div>
//                                 <div
//                                   className={`overflow-hidden transition-all duration-200 linear ${visiblePanels[questionData.qid]
//                                     ? "opacity-100 py-4"
//                                     : "opacity-0 py-0"
//                                     } my-4 px-6 bg-gray-100 border rounded-md text-[2.1rem]`}
//                                   style={{
//                                     maxHeight: visiblePanels[questionData.qid]
//                                       ? "1000px"
//                                       : "0",
//                                   }}
//                                 >
//                                   <p>
//                                     This is Evidence panel for:{" "}
//                                     <strong>{questionData.question}</strong>
//                                   </p>
//                                 </div>
//                                 <div className="list-banner flex bg-[#3a3a3a] py-5 text-white text-2xl text-center">
//                                   <p className="w-[80%] border-r-2 border-[#fff] text-3xl">
//                                     OPTIONS
//                                   </p>
//                                   <p className="w-[10%] border-r-2 border-[#fff] text-3xl">
//                                     CURRENT
//                                   </p>
//                                   <p className="w-[10%] text-3xl">DESIRED</p>
//                                 </div>
//                                 <div className="option-rows text-3xl">
//                                   {questionData.options.map((option, index) => (
//                                     <div
//                                       key={index}
//                                       style={{
//                                         fontFamily: "TCCC-UnityTextPC-Regular",
//                                       }}
//                                       className={`flex items-center border-b border-[#ccc]`}
//                                     >
//                                       <div className="w-[3%] flex text-center py-8 border-r border-[#ccc]">
//                                         <p className="w-full">
//                                           {index + 1 === 1
//                                             ? "A"
//                                             : index + 1 === 2
//                                               ? "B"
//                                               : index + 1 === 3
//                                                 ? "C"
//                                                 : "D"}
//                                         </p>
//                                       </div>
//                                       <p className="w-[77%] text-3xl pl-4 text-[#3c3c3a] py-6 border-r border-[#ccc]">
//                                         {option.text}
//                                       </p>
//                                       <div className="w-[10%] flex justify-center py-6 border-r border-[#ccc]">
//                                         <input
//                                           type="radio"
//                                           name={`current-${questionData.qid}`}
//                                           value={index}
//                                           checked={
//                                             currentSelections[
//                                             questionData.qid
//                                             ] === index
//                                           }
//                                           onChange={() =>
//                                             handleCurrentChange(
//                                               questionData.qid,
//                                               index
//                                             )
//                                           }
//                                           className="h-10 w-10 accent-[#f40009] cursor-pointer"
//                                         />
//                                       </div>
//                                       <div className="w-[10%] flex justify-center py-6">
//                                         <input
//                                           type="radio"
//                                           name={`desired-${questionData.qid}`}
//                                           value={index}
//                                           checked={
//                                             desiredSelections[
//                                             questionData.qid
//                                             ] === index
//                                           }
//                                           onChange={() =>
//                                             handleDesiredChange(
//                                               questionData.qid,
//                                               index
//                                             )
//                                           }
//                                           disabled={
//                                             currentSelections[
//                                             questionData.qid
//                                             ] !== undefined &&
//                                             index <
//                                             currentSelections[questionData.qid]
//                                           }
//                                           className={`h-10 w-10 accent-[#f40009] cursor-pointer ${currentSelections[
//                                             questionData.qid
//                                           ] !== undefined &&
//                                             index <
//                                             currentSelections[questionData.qid]
//                                             ? "opacity-50 cursor-not-allowed"
//                                             : ""
//                                             }`}
//                                         />
//                                       </div>
//                                     </div>
//                                   ))}
//                                 </div>
//                                 <div className="w-full mt-16 mb-16 border-b border-[#3a3a3a]">
//                                   <div className="flex flex-row gap-8 items-start">
//                                     <div className="w-[60%]">
//                                       <textarea
//                                         rows={7}
//                                         placeholder="Write Remark"
//                                         value={remarks[questionData.qid] || ""}
//                                         onChange={(e) =>
//                                           handleRemarksChange(
//                                             questionData.qid,
//                                             e.target.value
//                                           )
//                                         }
//                                         className="w-full resize-none overflow-hidden mb-4 p-3 border border-[#ccc] rounded-md focus:outline-none focus:ring-1 focus:ring-[#3a3a3a] text-3xl"
//                                         style={{
//                                           fontFamily: "TCCC-UnityTextPC-Regular",
//                                         }}
//                                         onInput={(e) => {
//                                           e.target.style.height = "auto";
//                                           e.target.style.height =
//                                             e.target.scrollHeight + "px";
//                                         }}
//                                       />
//                                     </div>
//                                     <div className="w-[15%] flex flex-col">
//                                       <label className="text-3xl mb-4">KPI Score</label>
//                                       <input
//                                         type="number"
//                                         value={kpiScores[questionData.qid] || item?.kpiScore || ""}
//                                         onChange={(e) => handleKpiScoreChange(questionData.qid, e.target.value)}
//                                         placeholder="Enter score"
//                                         className="w-full p-3 border border-[#ccc] rounded-md focus:outline-none focus:ring-1 focus:ring-[#3a3a3a] text-3xl"
//                                         style={{
//                                           fontFamily: "TCCC-UnityTextPC-Regular",
//                                         }}
//                                         min="0"
//                                         max="100"
//                                       />
//                                     </div>
//                                   </div>


//                                   <div className="mb-8">
//                                     <h3 className="text-3xl font-bold mb-6">Attachments:</h3>
//                                     <div className="grid grid-cols-5 gap-4">
//                                       {[1, 2, 3, 4, 5].map((_, index) => {
//                                         const attachmentKey = `attachment${index + 1}`;
//                                         const attachmentUrl = item?.[attachmentKey];
//                                         const isImage = attachmentUrl && /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(attachmentUrl);

//                                         return (
//                                           <div key={index} className="flex flex-col items-center">
//                                             <input
//                                               type="file"
//                                               ref={el => fileInputRefs.current[index] = el}
//                                               onChange={(e) => handleFileUpload(questionData.qid, index, e)}
//                                               className="hidden"
//                                               accept="image/*,.pdf,.doc,.docx"
//                                             />

//                                             {attachmentUrl ? (
//                                               <div className="relative">
//                                                 <div
//                                                   className="w-24 h-24 bg-gray-200 flex items-center justify-center mb-2 rounded-md cursor-pointer overflow-hidden"
//                                                   onClick={() => openImageModal(environment.imageUrl + attachmentUrl, `Attachment ${index + 1}`)}
//                                                 >
//                                                   {isImage ? (
//                                                     <img
//                                                       src={environment.imageUrl + attachmentUrl}
//                                                       alt={`Attachment ${index + 1}`}
//                                                       className="w-full h-full object-cover"
//                                                     />
//                                                   ) : (
//                                                     <span className="text-4xl">📎</span>
//                                                   )}
//                                                 </div>
//                                                 <button
//                                                   onClick={() => fileInputRefs.current[index]?.click()}
//                                                   className="absolute -top-2 -right-2 bg-[#f40009] text-white rounded-full w-8 h-8 flex items-center justify-center"
//                                                 >
//                                                   ↻
//                                                 </button>
//                                               </div>
//                                             ) : (
//                                               <button
//                                                 onClick={() => fileInputRefs.current[index]?.click()}
//                                                 className={`w-24 h-24 flex items-center justify-center mb-2 rounded-md ${uploadingIndex === index ? 'bg-gray-300' : 'bg-gray-100'
//                                                   }`}
//                                                 disabled={uploadingIndex === index}
//                                               >
//                                                 {uploadingIndex === index ? (
//                                                   <span className="text-2xl">⏳</span>
//                                                 ) : (
//                                                   <span className="text-4xl">+</span>
//                                                 )}
//                                               </button>
//                                             )}

//                                             {attachmentUrl ? (
//                                               <div className="flex">
//                                                 <a
//                                                   href={environment.imageUrl + attachmentUrl}
//                                                   target="_blank"
//                                                   rel="noopener noreferrer"
//                                                   className="text-2xl text-[#f40009] hover:underline text-center mr-2"
//                                                 >
//                                                   View
//                                                 </a>
//                                                 <button
//                                                   onClick={() => {
//                                                     // Implement delete functionality
//                                                   }}
//                                                   className="text-2xl text-red-600 hover:underline"
//                                                 >
//                                                   ×
//                                                 </button>
//                                               </div>
//                                             ) : (
//                                               <span className="text-2xl text-gray-500">
//                                                 {uploadingIndex === index ? 'Uploading...' : 'Add file'}
//                                               </span>
//                                             )}
//                                           </div>
//                                         );
//                                       })}
//                                     </div>
//                                   </div>
//                                   {/* <div className="mb-8">
//                                     <h3 className="text-3xl font-bold mb-6">Attachments:</h3>
//                                     <div className="grid grid-cols-5 gap-4">
//                                       {[item?.attachment1, item?.attachment2, item?.attachment3, item?.attachment4, item?.attachment5].map((attachment, index) => (
//                                         <div key={index} className="flex flex-col items-center">
//                                           {attachment ? (
//                                             <>
//                                               <div
//                                                 className="w-24 h-24 bg-gray-200 flex items-center justify-center mb-2 rounded-md cursor-pointer"
//                                                 onClick={() => openImageModal(attachment, `Attachment ${index + 1}`)}
//                                               >
//                                                 <span className="text-4xl">📎</span>
//                                               </div>
//                                               <a
//                                                 href={attachment}
//                                                 target="_blank"
//                                                 rel="noopener noreferrer"
//                                                 className="text-2xl text-[#f40009] hover:underline text-center"
//                                               >
//                                                 Attachment {index + 1}
//                                               </a>
//                                             </>
//                                           ) : (
//                                             <div className="w-24 h-24 bg-gray-100 flex items-center justify-center text-gray-400 text-2xl rounded-md">
//                                               N/A
//                                             </div>
//                                           )}
//                                         </div>
//                                       ))}
//                                     </div>
//                                   </div> */}
//                                 </div>
//                               </div>
//                             );
//                           })}
//                         </div>
//                       )}
//                     </div>
//                   </li>
//                 )
//             )}
//           </ul>
//         </div>
//       </div>
//       {modalData.isOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-70 z-[100000] flex items-center justify-center">
//           <div
//             className="bg-white rounded-lg relative overflow-auto"
//             style={{
//               height: "90dvh",
//               width: "auto",
//               display: "flex",
//               flexDirection: "column",
//               padding: "4rem",
//               maxHeight: "calc(100dvh - 2rem)",
//               maxWidth: "calc(100vw - 2rem)",
//             }}
//           >
//             <button
//               className="absolute top-2 right-4 text-6xl font-bold"
//               onClick={closeModal}
//             >
//               ×
//             </button>
//             {modalData.title && (
//               <h2 className="text-3xl font-bold mb-4">{modalData.title}</h2>
//             )}
//             <img
//               src={modalData.imageSrc}
//               alt="Modal content"
//               className="w-full h-full object-contain"
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


import { useEffect, useState, useRef } from "react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { ChevronRightIcon } from "@heroicons/react/24/solid";
import { useAssessment } from "../components/assessmentContext";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchAttachmentsForQuestiongid, GetAnswerData, GetChoicesByQID, post_InsertAnswer, sendAttachments } from "../apis/services/csaApi";
import * as environment from '../apis/env_config/environment'

export default function Question() {
  const [openPanels, setOpenPanels] = useState({});
  const { activeAssessment } = useAssessment();
  const location = useLocation();
  const navigate = useNavigate();
  const { groupname, enablers, questions, topic, phase, groupId, allGroupItems } =
    location.state || {};
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || 0);

  // State for question responses
  const [visiblePanels, setVisiblePanels] = useState({});
  const [currentSelections, setCurrentSelections] = useState({});
  const [desiredSelections, setDesiredSelections] = useState({});
  const [remarks, setRemarks] = useState({});
  const [optionsMap, setOptionsMap] = useState({});
  const [groupedQuestions, setGroupedQuestions] = useState({});
  const [kpiScores, setKpiScores] = useState({});
  const [attachments, setAttachments] = useState({});
  const [uploadingIndex, setUploadingIndex] = useState(null);
  const fileInputRefs = useRef([]);

  const get_Attachments_Data = async (newGroupedQuestions) => {
    try {
      const rawData = await fetchAttachmentsForQuestiongid(
        localStorage.getItem("uId"),
        localStorage.getItem("AssessmentId"),
        groupId
      );
      console.log("fetchAttachmentsForQuestiongid", rawData);
      
      if (rawData && rawData.length > 0) {
        const initialAttachments = {};
        
        rawData.forEach(item => {
          initialAttachments[item.qid] = {
            attachment1: item.attachment1,
            attachment2: item.attachment2,
            attachment3: item.attachment3,
            attachment4: item.attachment4,
            attachment5: item.attachment5
          };
        });
        
        setAttachments(initialAttachments);
      }
    } catch (error) {
      console.error(`Error fetching attachments`, error);
    }
  }

  const get_Answer_Data = async (newGroupedQuestions) => {
    try {
      const rawData = await GetAnswerData(
        localStorage.getItem("uId"),
        localStorage.getItem("AssessmentId"),
        groupId
      );
      console.log("GetAnswerData", rawData);
      if (rawData && rawData.length > 0) {
        
        // Initialize selections after groupedQuestions is set
        const {
          initialCurrentSelections,
          initialDesiredSelections,
          initialRemarks,
          initialKpiScores
        } = initializeSelectionsFromApiData(rawData, newGroupedQuestions);

        setCurrentSelections(initialCurrentSelections);
        setDesiredSelections(initialDesiredSelections);
        setRemarks(initialRemarks);
        setKpiScores(initialKpiScores);
      }
    } catch (error) {
      console.error(`Error fetching answers`, error);
    }
  }

  // Initialize selections from API data
  const initializeSelectionsFromApiData = (apiData, groupedQuestions) => {
    const initialCurrentSelections = {};
    const initialDesiredSelections = {};
    const initialRemarks = {};
    const initialKpiScores = {};

    apiData.forEach(item => {
      console.log("item", item);
      
      const qid = item.qid;
      console.log("qidII", qid);

      console.log("Object.keys(groupedQuestions)", groupedQuestions);

      // Find the question in groupedQuestions to get options
      const category = Object.keys(groupedQuestions).find(cat =>
        groupedQuestions[cat].some(q => q.qid === qid)
      );
      const question = groupedQuestions[category]?.find(q => q.qid === qid);
console.log("question", question);

      if (question) {
        // Find current selection index based on currentID (oid)
        const currentOptionIndex = question.options.findIndex(
          option => option.oid === item.currentID
        );
        console.log("currentOptionIndex", currentOptionIndex);
        if (currentOptionIndex !== -1) {
          initialCurrentSelections[qid] = currentOptionIndex;
        }

        // Find desired selection index based on destinationID (oid)
        const desiredOptionIndex = question.options.findIndex(
          option => option.oid === item.destinationID
        );
        console.log("desiredOptionIndex", desiredOptionIndex);
        if (desiredOptionIndex !== -1) {
          initialDesiredSelections[qid] = desiredOptionIndex;
        }

        // Set remarks if available
        if (item.remark) {
          initialRemarks[qid] = item.remark;
        }

        // Set KPI score if available
        if (item.kpiScore !== null && item.kpiScore !== undefined) {
          initialKpiScores[qid] = item.kpiScore;
        }
      }
    });
    console.log("initialCurrentSelections", initialCurrentSelections);
    console.log("initialDesiredSelections", initialDesiredSelections);
    console.log("initialRemarks", initialRemarks);
    console.log("initialKpiScores", initialKpiScores);

    return {
      initialCurrentSelections,
      initialDesiredSelections,
      initialRemarks,
      initialKpiScores
    };
  };

  // Update the fetchOptionsAndGroupQuestions useEffect to store both answerText and oid
  useEffect(() => {
    const fetchOptionsAndGroupQuestions = async () => {
      if (!allGroupItems) return;

      const newOptionsMap = {};
      const newGroupedQuestions = {
        "Human Talent & Organization": [],
        "Standardized Process & Governance": [],
        "Tools & Technology": [],
      };
      console.log("allGroupItemsd", allGroupItems);
      for (const item of allGroupItems) {
        try {
          const rawData = await GetChoicesByQID(
            null,
            item.id,
            localStorage.getItem("AssessmentId"),
            localStorage.getItem("userName"),
            localStorage.getItem("languageId")
          );
          console.log("GetChoicesByQID", rawData);

          if (rawData && rawData.length > 0 && rawData[0].length > 0) {
            // Store both answerText and oid for each option
            newOptionsMap[item.id] = rawData[0].map(option => ({
              text: option.answerText,
              oid: option.oid
            }));
          } else {
            // Default options with dummy oids if no data from API
            newOptionsMap[item.id] = [
              { text: "Not in Place", oid: 1 },
              { text: "Partially in Place", oid: 2 },
              { text: "Mostly in Place", oid: 3 },
              { text: "Fully in Place", oid: 4 }
            ];
          }

          if (newGroupedQuestions[item.enablers]) {
            newGroupedQuestions[item.enablers].push({
              qid: item.id,
              question: item.questions,
              options: newOptionsMap[item.id],
              itemData: item
            });
          }
        } catch (error) {
          console.error(`Error fetching options for QID ${item.id}:`, error);
          newOptionsMap[item.id] = [
            { text: "Not in Place", oid: 1 },
            { text: "Partially in Place", oid: 2 },
            { text: "Mostly in Place", oid: 3 },
            { text: "Fully in Place", oid: 4 }
          ];
        }
      }
      console.log("newGroupedQuestions", newGroupedQuestions);

      setOptionsMap(newOptionsMap);
      setGroupedQuestions(newGroupedQuestions);
      get_Attachments_Data(newGroupedQuestions);
      get_Answer_Data(newGroupedQuestions);
    }

    fetchOptionsAndGroupQuestions();
  }, [allGroupItems]);

  const goBackToQuestionnaires = () => {
    navigate("/questionnaires", {
      state: {
        activeTab,
        openPhase: phase,
      },
    });
  };

  const togglePanel = (panelName) => {
    setOpenPanels((prevState) => ({
      ...prevState,
      [panelName]: !prevState[panelName],
    }));
  };

  const toggleQuestionPanel = (qid) => {
    setVisiblePanels((prev) => ({ ...prev, [qid]: !prev[qid] }));
  };

  const logQuestionData = async (qid, changeType, value = null) => {
    const category = Object.keys(groupedQuestions).find(cat =>
      groupedQuestions[cat].some(q => q.qid === qid)
    );
    const question = groupedQuestions[category]?.find(q => q.qid === qid);

    if (!question) return;

    const item = question.itemData;
    console.log("question", question);
    console.log("item", item);

    const dataToLog = {
      qid: qid,
      question: question.question,
      options: question.options.map((option, index) => ({
        optionText: option.text,
        optionId: option.oid,
        selected: currentSelections[qid] === index || desiredSelections[qid] === index,
        currentSelection: currentSelections[qid] === index,
        desiredSelection: desiredSelections[qid] === index
      })),
      currentValue: changeType === 'current' ? value : currentSelections[qid] !== undefined
        ? {
          text: question.options[currentSelections[qid]].text,
          oid: question.options[currentSelections[qid]].oid
        }
        : null,
      desiredValue: changeType === 'desired' ? value : desiredSelections[qid] !== undefined
        ? {
          text: question.options[desiredSelections[qid]].text,
          oid: question.options[desiredSelections[qid]].oid
        }
        : null,
      kpiScore: changeType === 'kpiScore' ? value : kpiScores[qid] || item?.kpiScore || null,
      attachments: attachments[qid] || {},
      remarks: changeType === 'remarks' ? value : remarks[qid] || null,
      changeType: changeType
    };

    let apiData = {
      qid: qid,
      Cid: 0,
      DId: 0,
      UId: localStorage.getItem("uId"),
      AID: localStorage.getItem("AssessmentId"),
      Remarks: dataToLog.remarks || "",
      Eid: item.enablerId || 0,
      GID: item.groupId || 0,
      Fid: 0,
      GroupName: groupname || "",
      UserName: "admin",
      Ip: "",
      kpiScore: dataToLog.kpiScore || 0,
    };

    // Set Cid or DId based on changeType
    if (changeType === 'current' && value?.oid) {
      apiData.Cid = value.oid;
    } else if (changeType === 'desired' && value?.oid) {
      apiData.DId = value.oid;
    } else if (changeType === 'remarks') {
      apiData.Remarks = value || "";
      if (currentSelections[qid] !== undefined) {
        apiData.Cid = question.options[currentSelections[qid]].oid;
      }
      if (desiredSelections[qid] !== undefined) {
        apiData.DId = question.options[desiredSelections[qid]].oid;
      }
    } else if (changeType === 'kpiScore') {
      if (currentSelections[qid] !== undefined) {
        apiData.Cid = question.options[currentSelections[qid]].oid;
      }
      if (desiredSelections[qid] !== undefined) {
        apiData.DId = question.options[desiredSelections[qid]].oid;
      }
    }

    // Make API call
    try {
      const response = await post_InsertAnswer(apiData);
      console.log('API Response:', response);
    } catch (error) {
      console.error('API Error:', error);
    }

    console.log(`Question ${qid} Update (${changeType}):`, dataToLog);
    return dataToLog;
  };

  const logEnablerData = (category) => {
    if (!groupedQuestions[category]) return;

    const enablerData = {
      category: category,
      questions: [],
      completeStatus: getCategoryStatus(category).includes('green') ? 'complete' : 'incomplete'
    };

    groupedQuestions[category].forEach(questionData => {
      const qid = questionData.qid;
      enablerData.questions.push(logQuestionData(qid, 'enabler'));
    });

    console.log(`Enabler ${category} Data:`, enablerData);
    return enablerData;
  };

  const handleCurrentChange = (qid, index) => {
    const category = Object.keys(groupedQuestions).find(cat =>
      groupedQuestions[cat].some(q => q.qid === qid)
    );
    const question = groupedQuestions[category]?.find(q => q.qid === qid);
    const selectedOption = question?.options[index];

    setCurrentSelections(prev => ({ ...prev, [qid]: index }));

    setDesiredSelections(prev => {
      if (prev[qid] !== undefined && prev[qid] < index) {
        const updated = { ...prev };
        delete updated[qid];
        return updated;
      }
      return prev;
    });

    logQuestionData(qid, 'current', {
      text: selectedOption.text,
      oid: selectedOption.oid
    });
    logEnablerData(category);
  };

  const handleDesiredChange = (qid, index) => {
    if (currentSelections[qid] === undefined || index >= currentSelections[qid]) {
      const category = Object.keys(groupedQuestions).find(cat =>
        groupedQuestions[cat].some(q => q.qid === qid)
      );
      const question = groupedQuestions[category]?.find(q => q.qid === qid);
      const selectedOption = question?.options[index];

      setDesiredSelections(prev => ({ ...prev, [qid]: index }));
      logQuestionData(qid, 'desired', {
        text: selectedOption.text,
        oid: selectedOption.oid
      });
      logEnablerData(category);
    }
  };

  const handleRemarksChange = (qid, value) => {
    setRemarks((prev) => ({ ...prev, [qid]: value }));

    const category = Object.keys(groupedQuestions).find(cat =>
      groupedQuestions[cat].some(q => q.qid === qid)
    );

    logQuestionData(qid, 'remarks', value);
    logEnablerData(category);
  };

  const handleKpiScoreChange = (qid, value) => {
    setKpiScores(prev => ({
      ...prev,
      [qid]: value
    }));

    const category = Object.keys(groupedQuestions).find(cat =>
      groupedQuestions[cat].some(q => q.qid === qid)
    );

    logQuestionData(qid, 'kpiScore', value);
    logEnablerData(category);
  };

  const handleFileUpload = async (qid, index, e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadingIndex(index);
    const attachmentKey = `attachment${index + 1}`;

    try {
      const uploadResponse = await sendAttachments({
        file,
        qid,
        index: index + 1,
        assessmentId: localStorage.getItem("AssessmentId"),
        userName: localStorage.getItem("userName"),
        uid: localStorage.getItem("uId"),
        gid: groupId
      });

      const filePath = uploadResponse.filePath;
      console.log('File uploaded successfully:', filePath);

      setAttachments(prev => ({
        ...prev,
        [qid]: {
          ...prev[qid],
          [attachmentKey]: filePath
        }
      }));

      logQuestionData(qid, attachmentKey, {
        name: file.name,
        type: file.type,
        size: file.size,
        url: filePath,
        lastModified: file.lastModified
      });

      const category = Object.keys(groupedQuestions).find(cat =>
        groupedQuestions[cat].some(q => q.qid === qid)
      );
      logEnablerData(category);

    } catch (error) {
      console.error('Error uploading file:', error);
      logQuestionData(qid, `${attachmentKey}_error`, error.message);
    } finally {
      setUploadingIndex(null);
    }
  };

  const handleDeleteAttachment = (qid, index) => {
    const attachmentKey = `attachment${index + 1}`;
    
    setAttachments(prev => {
      const newAttachments = { ...prev };
      if (newAttachments[qid]) {
        newAttachments[qid] = { ...newAttachments[qid] };
        delete newAttachments[qid][attachmentKey];
      }
      return newAttachments;
    });

    // You may want to add an API call here to delete the attachment from the server
    logQuestionData(qid, `${attachmentKey}_delete`);
  };

  const getCategoryStatus = (category) => {
    if (!groupedQuestions[category] || groupedQuestions[category].length === 0) {
      return "bg-red-600";
    }

    const questions = groupedQuestions[category];
    let hasComplete = false;
    let hasPartial = false;
    let hasNone = false;

    questions.forEach((question) => {
      const qid = question.qid;
      const hasCurrent = currentSelections[qid] !== undefined;
      const hasDesired = desiredSelections[qid] !== undefined;

      if (hasCurrent && hasDesired) {
        hasComplete = true;
      } else if (hasCurrent || hasDesired) {
        hasPartial = true;
      } else {
        hasNone = true;
      }
    });

    if (hasComplete && !hasNone) {
      return "bg-[#02a902]";
    } else {
      return "bg-[#f40009]";
    }
  };

  // Evidence modal
  const [modalData, setModalData] = useState({
    isOpen: false,
    imageSrc: null,
    title: null
  });

  const openImageModal = (src, title = null) => {
    setModalData({ isOpen: true, imageSrc: src, title });
  };

  const closeModal = () => {
    setModalData({ isOpen: false, imageSrc: null, title: null });
  };

  useEffect(() => {
    if (modalData.isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [modalData.isOpen]);

  // Render function remains the same, just make sure to use the attachments state for displaying files
  // The attachments section in the render should look like this:
  /*
  {[0, 1, 2, 3, 4].map((index) => {
    const attachmentKey = `attachment${index + 1}`;
    const attachmentUrl = attachments[questionData.qid]?.[attachmentKey];
    const isImage = attachmentUrl && /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(attachmentUrl);

    return (
      <div key={index} className="flex flex-col items-center">
        <input
          type="file"
          ref={el => fileInputRefs.current[index] = el}
          onChange={(e) => handleFileUpload(questionData.qid, index, e)}
          className="hidden"
          accept="image/*,.pdf,.doc,.docx"
        />

        {attachmentUrl ? (
          <div className="relative">
            <div
              className="w-24 h-24 bg-gray-200 flex items-center justify-center mb-2 rounded-md cursor-pointer overflow-hidden"
              onClick={() => openImageModal(environment.imageUrl + attachmentUrl, `Attachment ${index + 1}`)}
            >
              {isImage ? (
                <img
                  src={environment.imageUrl + attachmentUrl}
                  alt={`Attachment ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              ) : (
                <span className="text-4xl">📎</span>
              )}
            </div>
            <button
              onClick={() => fileInputRefs.current[index]?.click()}
              className="absolute -top-2 -right-2 bg-[#f40009] text-white rounded-full w-8 h-8 flex items-center justify-center"
            >
              ↻
            </button>
            <button
              onClick={() => handleDeleteAttachment(questionData.qid, index)}
              className="absolute -top-2 -right-12 bg-red-600 text-white rounded-full w-8 h-8 flex items-center justify-center"
            >
              ×
            </button>
          </div>
        ) : (
          <button
            onClick={() => fileInputRefs.current[index]?.click()}
            className={`w-24 h-24 flex items-center justify-center mb-2 rounded-md ${uploadingIndex === index ? 'bg-gray-300' : 'bg-gray-100'}`}
            disabled={uploadingIndex === index}
          >
            {uploadingIndex === index ? (
              <span className="text-2xl">⏳</span>
            ) : (
              <span className="text-4xl">+</span>
            )}
          </button>
        )}

        {attachmentUrl ? (
          <div className="flex">
            <a
              href={environment.imageUrl + attachmentUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl text-[#f40009] hover:underline text-center mr-2"
            >
              View
            </a>
          </div>
        ) : (
          <span className="text-2xl text-gray-500">
            {uploadingIndex === index ? 'Uploading...' : 'Add file'}
          </span>
        )}
      </div>
    );
  })}
  */

  return (
    <div className="wrapper">
      <div className="section-questions" style={{ alignItems: "flex-start" }}>
        <h1 className="main-heading">
          {topic} {localStorage.getItem("AssessmentText")} Breakdown
        </h1>

        {/* Breadcrumb navigation */}
        <nav
          className="text-3xl w-full mb-12 mt-24"
          style={{ fontFamily: "TCCC-UnityTextPC-Bold", color: "#3c3c3a" }}
        >
          <ol className="flex items-center relative">
            <li className="flex items-center hover:text-[#f40009]">
              <button onClick={goBackToQuestionnaires} className="text-4xl">
                {topic}
              </button>
              <ChevronRightIcon className="h-5 w-5 mx-3 text-gray-900" />
            </li>
            <li className="flex items-center">
              <span className="text-4xl">{phase}</span>
              <ChevronRightIcon className="h-5 w-5 mx-3 text-gray-900" />
            </li>
            <li className="flex items-center">
              <span className="text-black m-0 text-4xl">{groupname}</span>
            </li>
            <span
              onClick={() =>
                setModalData({
                  isOpen: true,
                  imageSrc: `/assets/elements/${groupname}.svg`,
                  title: groupname
                })
              }
              className="absolute top-0 right-0 w-12 h-12 bg-[#f40009] rounded-full cursor-pointer"
            >
              <span className="absolute top-[51%] left-1/2 -translate-x-[50%] -translate-y-[55%] text-3xl text-white">
                i
              </span>
            </span>
          </ol>
        </nav>

        {/* Questions section - grouped by category */}
        <div className="methods-content-container">
          <ul>
            {Object.entries(groupedQuestions).map(
              ([category, questions]) =>
                questions.length > 0 && (
                  <li key={category} className="text-gray-800 font-medium">
                    <div>
                      <button
                        className={`flex content-center items-center w-full ${getCategoryStatus(
                          category
                        )}`}
                        onClick={() => togglePanel(category)}
                      >
                        <div
                          className="phase w-[6rem] border-r border-[#ccc]"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            className="w-[3rem] h-[3rem]"
                            src={
                              category === "Human Talent & Organization"
                                ? "/assets/main/hr.svg"
                                : category ===
                                  "Standardized Process & Governance"
                                  ? "/assets/main/process.svg"
                                  : "/assets/main/it.svg"
                            }
                            alt=""
                          />
                        </div>
                        <p
                          className="phase"
                          style={{
                            padding: "1rem 1rem",
                            fontFamily: "TCCC-UnityTextPC-Bold",
                            fontSize: "2.5rem",
                          }}
                        >
                          {category}
                        </p>
                        <ChevronDownIcon
                          className={`h-10 w-10 ml-auto mr-4 text-white transition-transform duration-200 ${openPanels[category] ? "rotate-180" : ""
                            }`}
                        />
                      </button>

                      {openPanels[category] && (
                        <div className="group-name-container px-4 bg-white">
                          {questions.map((questionData, qIndex) => {
                            const item = questionData.itemData;
                            return (
                              <div
                                key={qIndex}
                                className="question-container px-3"
                              >
                                <div
                                  className="text-2xl px-6 my-5 border-l-2 border-[#f40009] relative"
                                  style={{
                                    fontFamily: "TCCC-UnityTextPC-Regular",
                                  }}
                                >
                                  <p className="w-[92%] text-[2.4rem] leading-normal">
                                    {questionData.qid}. {questionData.question}
                                  </p>
                                  <span
                                    style={{
                                      fontFamily: "TCCC-UnityTextPC-Bold",
                                    }}
                                    onClick={() =>
                                      toggleQuestionPanel(questionData.qid)
                                    }
                                    className="absolute right-0 top-1/2 -translate-y-1/2 w-14 h-14 bg-[#f40009] rounded-full cursor-pointer"
                                  >
                                    <span className="absolute top-[45%] left-1/2 -translate-x-[45%] -translate-y-[55%] text-3xl text-white">
                                      e
                                    </span>
                                  </span>
                                  {item?.hqLink && (
                                    <span
                                      onClick={() => openImageModal(item.hqLink, questionData.question)}
                                      className="absolute right-[5.2rem] top-1/2 -translate-y-1/2 w-14 h-14 bg-[#f40009] rounded-full cursor-pointer"
                                    >
                                      <span className="absolute top-[51%] left-1/2 -translate-x-[45%] -translate-y-[55%] text-4xl text-white">
                                        i
                                      </span>
                                    </span>
                                  )}
                                </div>
                                <div
                                  className={`overflow-hidden transition-all duration-200 linear ${visiblePanels[questionData.qid]
                                    ? "opacity-100 py-4"
                                    : "opacity-0 py-0"
                                    } my-4 px-6 bg-gray-100 border rounded-md text-[2.1rem]`}
                                  style={{
                                    maxHeight: visiblePanels[questionData.qid]
                                      ? "1000px"
                                      : "0",
                                  }}
                                >
                                  <p>
                                    This is Evidence panel for:{" "}
                                    <strong>{questionData.question}</strong>
                                  </p>
                                </div>
                                <div className="list-banner flex bg-[#3a3a3a] py-5 text-white text-2xl text-center">
                                  <p className="w-[80%] border-r-2 border-[#fff] text-3xl">
                                    OPTIONS
                                  </p>
                                  <p className="w-[10%] border-r-2 border-[#fff] text-3xl">
                                    CURRENT
                                  </p>
                                  <p className="w-[10%] text-3xl">DESIRED</p>
                                </div>
                                <div className="option-rows text-3xl">
                                  {questionData.options.map((option, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        fontFamily: "TCCC-UnityTextPC-Regular",
                                      }}
                                      className={`flex items-center border-b border-[#ccc]`}
                                    >
                                      <div className="w-[3%] flex text-center py-8 border-r border-[#ccc]">
                                        <p className="w-full">
                                          {index + 1 === 1
                                            ? "A"
                                            : index + 1 === 2
                                              ? "B"
                                              : index + 1 === 3
                                                ? "C"
                                                : "D"}
                                        </p>
                                      </div>
                                      <p className="w-[77%] text-3xl pl-4 text-[#3c3c3a] py-6 border-r border-[#ccc]">
                                        {option.text}
                                      </p>
                                      <div className="w-[10%] flex justify-center py-6 border-r border-[#ccc]">
                                        <input
                                          type="radio"
                                          name={`current-${questionData.qid}`}
                                          value={index}
                                          checked={
                                            currentSelections[
                                            questionData.qid
                                            ] === index
                                          }
                                          onChange={() =>
                                            handleCurrentChange(
                                              questionData.qid,
                                              index
                                            )
                                          }
                                          className="h-10 w-10 accent-[#f40009] cursor-pointer"
                                        />
                                      </div>
                                      <div className="w-[10%] flex justify-center py-6">
                                        <input
                                          type="radio"
                                          name={`desired-${questionData.qid}`}
                                          value={index}
                                          checked={
                                            desiredSelections[
                                            questionData.qid
                                            ] === index
                                          }
                                          onChange={() =>
                                            handleDesiredChange(
                                              questionData.qid,
                                              index
                                            )
                                          }
                                          disabled={
                                            currentSelections[
                                            questionData.qid
                                            ] !== undefined &&
                                            index <
                                            currentSelections[questionData.qid]
                                          }
                                          className={`h-10 w-10 accent-[#f40009] cursor-pointer ${currentSelections[
                                            questionData.qid
                                          ] !== undefined &&
                                            index <
                                            currentSelections[questionData.qid]
                                            ? "opacity-50 cursor-not-allowed"
                                            : ""
                                            }`}
                                        />
                                      </div>
                                    </div>
                                  ))}
                                </div>
                                <div className="w-full mt-16 mb-16 border-b border-[#3a3a3a]">
                                  <div className="flex flex-row gap-8 items-start">
                                    <div className="w-[60%]">
                                      <textarea
                                        rows={7}
                                        placeholder="Write Remark"
                                        value={remarks[questionData.qid] || ""}
                                        onChange={(e) =>
                                          handleRemarksChange(
                                            questionData.qid,
                                            e.target.value
                                          )
                                        }
                                        className="w-full resize-none overflow-hidden mb-4 p-3 border border-[#ccc] rounded-md focus:outline-none focus:ring-1 focus:ring-[#3a3a3a] text-3xl"
                                        style={{
                                          fontFamily: "TCCC-UnityTextPC-Regular",
                                        }}
                                        onInput={(e) => {
                                          e.target.style.height = "auto";
                                          e.target.style.height =
                                            e.target.scrollHeight + "px";
                                        }}
                                      />
                                    </div>
                                    <div className="w-[15%] flex flex-col">
                                      <label className="text-3xl mb-4">KPI Score</label>
                                      <input
                                        type="number"
                                        value={kpiScores[questionData.qid] || item?.kpiScore || ""}
                                        onChange={(e) => handleKpiScoreChange(questionData.qid, e.target.value)}
                                        placeholder="Enter score"
                                        className="w-full p-3 border border-[#ccc] rounded-md focus:outline-none focus:ring-1 focus:ring-[#3a3a3a] text-3xl"
                                        style={{
                                          fontFamily: "TCCC-UnityTextPC-Regular",
                                        }}
                                        min="0"
                                        max="100"
                                      />
                                    </div>
                                  </div>

                                  <div className="mb-8">
                                    <h3 className="text-3xl font-bold mb-6">Attachments:</h3>
                                    <div className="grid grid-cols-5 gap-4">
                                      {[0, 1, 2, 3, 4].map((index) => {
                                        const attachmentKey = `attachment${index + 1}`;
                                        const attachmentUrl = attachments[questionData.qid]?.[attachmentKey];
                                        const isImage = attachmentUrl && /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(attachmentUrl);

                                        return (
                                          <div key={index} className="flex flex-col items-center">
                                            <input
                                              type="file"
                                              ref={el => fileInputRefs.current[index] = el}
                                              onChange={(e) => handleFileUpload(questionData.qid, index, e)}
                                              className="hidden"
                                              accept="image/*,.pdf,.doc,.docx"
                                            />

                                            {attachmentUrl ? (
                                              <div className="relative">
                                                <div
                                                  className="w-24 h-24 bg-gray-200 flex items-center justify-center mb-2 rounded-md cursor-pointer overflow-hidden"
                                                  onClick={() => openImageModal(environment.imageUrl + attachmentUrl, `Attachment ${index + 1}`)}
                                                >
                                                  {isImage ? (
                                                    <img
                                                      src={environment.imageUrl + attachmentUrl}
                                                      alt={`Attachment ${index + 1}`}
                                                      className="w-full h-full object-cover"
                                                    />
                                                  ) : (
                                                    <span className="text-4xl">📎</span>
                                                  )}
                                                </div>
                                                <button
                                                  onClick={() => fileInputRefs.current[index]?.click()}
                                                  className="absolute -top-2 -right-2 bg-[#f40009] text-white rounded-full w-8 h-8 flex items-center justify-center"
                                                >
                                                  ↻
                                                </button>
                                                <button
                                                  onClick={() => handleDeleteAttachment(questionData.qid, index)}
                                                  className="absolute -top-2 -right-12 bg-red-600 text-white rounded-full w-8 h-8 flex items-center justify-center"
                                                >
                                                  ×
                                                </button>
                                              </div>
                                            ) : (
                                              <button
                                                onClick={() => fileInputRefs.current[index]?.click()}
                                                className={`w-24 h-24 flex items-center justify-center mb-2 rounded-md ${uploadingIndex === index ? 'bg-gray-300' : 'bg-gray-100'}`}
                                                disabled={uploadingIndex === index}
                                              >
                                                {uploadingIndex === index ? (
                                                  <span className="text-2xl">⏳</span>
                                                ) : (
                                                  <span className="text-4xl">+</span>
                                                )}
                                              </button>
                                            )}

                                            {attachmentUrl ? (
                                              <div className="flex">
                                                <a
                                                  href={environment.imageUrl + attachmentUrl}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="text-2xl text-[#f40009] hover:underline text-center mr-2"
                                                >
                                                  View
                                                </a>
                                              </div>
                                            ) : (
                                              <span className="text-2xl text-gray-500">
                                                {uploadingIndex === index ? 'Uploading...' : 'Add file'}
                                              </span>
                                            )}
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </li>
                )
            )}
          </ul>
        </div>
      </div>
      {modalData.isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-[100000] flex items-center justify-center">
          <div
            className="bg-white rounded-lg relative overflow-auto"
            style={{
              height: "90dvh",
              width: "auto",
              display: "flex",
              flexDirection: "column",
              padding: "4rem",
              maxHeight: "calc(100dvh - 2rem)",
              maxWidth: "calc(100vw - 2rem)",
            }}
          >
            <button
              className="absolute top-2 right-4 text-6xl font-bold"
              onClick={closeModal}
            >
              ×
            </button>
            {modalData.title && (
              <h2 className="text-3xl font-bold mb-4">{modalData.title}</h2>
            )}
            <img
              src={modalData.imageSrc}
              alt="Modal content"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
}